import { useDataChange } from 'Simple/Data.js'
export function useOnClick(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'selected',
  })
  return function onClick() {
    change(next => {
      next.data.new_task = {
        ...next.data.new_task,
        actions: [],
      }
    })
  }
}
